module.exports = __webpack_public_path__ + "static/media/inbound-carousel-2.47f72371.png";